import * as React from 'react';
const SvgCurrencyEuro = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={20}
        height={20}
        fill='none'
        {...props}>

        <g>
            <path
                fill='currentColor'
                d='M12.016 16.584q-2.31 0-4-1.306a6.67 6.67 0 0 1-2.336-3.316H3.846a.52.52 0 0 1-.383-.16.52.52 0 0 1-.158-.382q0-.224.158-.383a.52.52 0 0 1 .383-.159h1.605a4 4 0 0 1-.058-.754q0-.471.058-1.002H3.846a.52.52 0 0 1-.383-.159.52.52 0 0 1-.158-.383q0-.224.158-.383a.52.52 0 0 1 .383-.158h1.85a6.63 6.63 0 0 1 2.323-3.317q1.688-1.305 3.997-1.305 1.228 0 2.315.405 1.085.405 1.97 1.122a.55.55 0 0 1 .175.367.49.49 0 0 1-.152.387.54.54 0 0 1-.404.167.6.6 0 0 1-.413-.17 6 6 0 0 0-1.617-.88 5.5 5.5 0 0 0-1.874-.315q-1.84 0-3.212 1.007-1.37 1.006-1.969 2.532h4.591q.224 0 .383.159a.52.52 0 0 1 .159.383q0 .225-.159.382a.52.52 0 0 1-.383.16H6.534q-.05.196-.068.682-.02.485.068 1.074h4.892q.224 0 .383.158a.52.52 0 0 1 .159.383q0 .224-.159.383a.52.52 0 0 1-.383.159H6.827q.606 1.525 1.977 2.532 1.373 1.006 3.212 1.006a5.6 5.6 0 0 0 3.49-1.185.65.65 0 0 1 .403-.187q.225-.018.397.154a.54.54 0 0 1-.005.774 7 7 0 0 1-1.97 1.123 6.6 6.6 0 0 1-2.315.405'
            />
        </g>
    </svg>
);
export default SvgCurrencyEuro;
